/* eslint-disable no-template-curly-in-string */
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import Wrong from '@assets/wrong.svg';
import { EmailAddress } from '@constants';
import classes from './error.module.css';

const TITLE = {
  noPass: 'Something went wrong',
};

export default function Error() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const message = state?.message;

  const handleClick = () => {
    navigate('/');
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>
        <img src={Wrong} alt="" className={classes.icon} />
        <div className={classes.error_text}>Oops!</div>
        <div className={classes.title}>
          {`${message || TITLE.noPass}. `}
          <span>
            {' Should you have any questions, please contact us at '}
            <a href={`mailto: ${EmailAddress.Seel}`} style={{ color: '#645AFF' }}>
              {EmailAddress.Seel}
            </a>
            .
          </span>
        </div>
        {/* <div dangerouslySetInnerHTML={{ __html: TITLE.noPass }}></div> */}

        <Button onClick={handleClick}>Back to home</Button>
      </div>
    </div>

  );
}
